import React, { Component } from "react";
import { Link } from "react-router-dom";

import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { PersonalTrainingData, BusinessTrainingData } from "../Data/CommunityCoursesData";

import "./Training.css";

/* ─── Inline SVG icons ─── */
const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
  </svg>
);

const ChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m6 9 6 6 6-6"/>
  </svg>
);

const UserGroup = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const Briefcase = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
  </svg>
);

const CheckCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <polyline points="22 4 12 14.01 9 11.01"/>
  </svg>
);

const Clock = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);

const Heart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
  </svg>
);

const GraduationCap = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"/>
  </svg>
);

class Training extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  render() {
    return (
      <div className="training-page">
        <Navbar />

        {/* ── HERO ── */}
        <section className="tp-hero">
          <div className="tp-hero__bg">
            <div className="tp-hero__glow tp-hero__glow--1" aria-hidden="true" />
            <div className="tp-hero__glow tp-hero__glow--2" aria-hidden="true" />
          </div>

          <div className="tp-hero__content">
            <span className="tp-hero__eyebrow">Community Interest Company · Est. 2013 · East London</span>

            <h1 className="tp-hero__title">
              Real Training.<br />
              <span className="tp-hero__title-accent">Real Futures.</span>
            </h1>

            <p className="tp-hero__subtitle">
              Accredited qualifications and life skills programmes for individuals facing barriers
              to work — and for organisations looking to upskill their teams.
              Free or funded for eligible learners.
            </p>

            <div className="tp-hero__ctas">
              <button
                className="tp-btn tp-btn--primary"
                onClick={() => this.scrollToSection("personal-courses")}
              >
                I want to learn <ChevronDown />
              </button>
              <button
                className="tp-btn tp-btn--secondary"
                onClick={() => this.scrollToSection("business-courses")}
              >
                Train my organisation <ChevronDown />
              </button>
            </div>
          </div>

          <div className="tp-hero__statsbar">
            <div className="tp-hero__stat">
              <span className="tp-hero__stat-n">750+</span>
              <span className="tp-hero__stat-l">Members reached</span>
            </div>
            <div className="tp-hero__stat-divider" aria-hidden="true" />
            <div className="tp-hero__stat">
              <span className="tp-hero__stat-n">45.7%</span>
              <span className="tp-hero__stat-l">Into employment</span>
            </div>
            <div className="tp-hero__stat-divider" aria-hidden="true" />
            <div className="tp-hero__stat">
              <span className="tp-hero__stat-n">100+</span>
              <span className="tp-hero__stat-l">Qualifications</span>
            </div>
            <div className="tp-hero__stat-divider" aria-hidden="true" />
            <div className="tp-hero__stat">
              <span className="tp-hero__stat-n">Free</span>
              <span className="tp-hero__stat-l">for eligible learners</span>
            </div>
          </div>
        </section>

        {/* ── WHO THIS IS FOR ── */}
        <section className="tp-audience">
          <div className="tp-audience__inner">
            <p className="tp-eyebrow">Who we help</p>
            <h2 className="tp-section-title">Training built around people, not programmes</h2>
            <p className="tp-section-sub">
              Whether you're starting from scratch or building a stronger workforce, we have
              a clear path for you.
            </p>

            <div className="tp-audience__cards">
              {/* Individual card */}
              <div className="tp-audience__card tp-audience__card--teal">
                <div className="tp-audience__card-top">
                  <div className="tp-audience__icon tp-audience__icon--teal">
                    <UserGroup />
                  </div>
                  <div>
                    <h3>For Individuals</h3>
                    <p className="tp-audience__sub">Personal training pathways</p>
                  </div>
                </div>
                <p className="tp-audience__desc">
                  We work with women returning to work, asylum seekers, migrants, people with
                  low-level qualifications, and anyone who needs a second chance. No
                  experience required. Just show up.
                </p>
                <ul className="tp-audience__list">
                  <li><CheckCircle /><span>Asylum seekers &amp; refugees</span></li>
                  <li><CheckCircle /><span>Women returning to work</span></li>
                  <li><CheckCircle /><span>Migrants &amp; new UK arrivals</span></li>
                  <li><CheckCircle /><span>Adults seeking accredited qualifications</span></li>
                  <li><CheckCircle /><span>Job seekers needing career support</span></li>
                </ul>
                <Link
                  to="/training/personal"
                  className="tp-audience__cta tp-audience__cta--teal"
                >
                  See individual courses <ArrowRight />
                </Link>
              </div>

              {/* Business card */}
              <div className="tp-audience__card tp-audience__card--orange">
                <div className="tp-audience__card-top">
                  <div className="tp-audience__icon tp-audience__icon--orange">
                    <Briefcase />
                  </div>
                  <div>
                    <h3>For Organisations</h3>
                    <p className="tp-audience__sub">Business training packages</p>
                  </div>
                </div>
                <p className="tp-audience__desc">
                  Care providers, nurseries, hospitality businesses, and charities trust APT
                  to keep their teams compliant, confident, and effective. Delivered on-site or
                  flexibly around your schedule.
                </p>
                <ul className="tp-audience__list">
                  <li><CheckCircle /><span>Care homes &amp; healthcare providers</span></li>
                  <li><CheckCircle /><span>Nurseries &amp; early years settings</span></li>
                  <li><CheckCircle /><span>SMEs and office-based teams</span></li>
                  <li><CheckCircle /><span>Hospitality &amp; catering businesses</span></li>
                  <li><CheckCircle /><span>Charities &amp; community organisations</span></li>
                </ul>
                <Link
                  to="/training/business"
                  className="tp-audience__cta tp-audience__cta--orange"
                >
                  See business packages <ArrowRight />
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* ── FUNDING BANNER ── */}
        <div className="tp-funding-banner">
          <div className="tp-funding-banner__inner">
            <span className="tp-funding-banner__dot" aria-hidden="true" />
            <p>
              <strong>Many of our courses are free or fully funded</strong> for eligible
              learners. No previous experience needed. Multilingual support available.{" "}
              <Link to="/contact" className="tp-funding-banner__link">
                Check your eligibility →
              </Link>
            </p>
          </div>
        </div>

        {/* ── PERSONAL TRAINING ── */}
        <section id="personal-courses" className="tp-courses tp-courses--personal">
          <div className="tp-courses__inner">
            <div className="tp-courses__header">
              <span className="tp-eyebrow tp-eyebrow--teal">Personal Training</span>
              <h2 className="tp-section-title">Training for Individuals</h2>
              <p className="tp-section-sub">
                From ESOL and Functional Skills to professional accreditations — every course
                is a stepping stone toward confidence, employment, and independence.
              </p>
            </div>

            {PersonalTrainingData.map((category) => (
              <div key={category.id} className="tp-category-section">
                <div className="tp-category-header">
                  <div className="tp-category-header__icon">
                    {category.category === "professional" ? (
                      <GraduationCap />
                    ) : (
                      <Heart />
                    )}
                  </div>
                  <div className="tp-category-header__text">
                    <h3 className="tp-category-header__title">{category.title}</h3>
                    <p className="tp-category-header__desc">{category.shortDescription}</p>
                  </div>
                </div>

                <div className="tp-programmes-grid">
                  {category.programs.map((programme, idx) => (
                    <Link
                      key={programme.id}
                      to={`/training/personal/${category.id}/${programme.id}`}
                      className="tp-programme-card"
                      style={{ animationDelay: `${idx * 0.05}s` }}
                    >
                      <div className="tp-programme-card__header">
                        <h4 className="tp-programme-card__name">{programme.name}</h4>
                        {programme.level && (
                          <span className="tp-programme-card__level">{programme.level}</span>
                        )}
                      </div>
                      <p className="tp-programme-card__desc">{programme.shortDescription}</p>
                      <div className="tp-programme-card__footer">
                        <span className="tp-programme-card__duration">
                          <Clock />
                          {programme.duration}
                        </span>
                        <span className="tp-programme-card__link">
                          View details <ArrowRight />
                        </span>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            ))}

            <div className="tp-courses__cta">
              <p>Not sure which course is right for you?</p>
              <Link to="/contact" className="tp-btn tp-btn--outline-teal">
                Book a free consultation
              </Link>
            </div>
          </div>
        </section>

        {/* ── BUSINESS TRAINING ── */}
        <section id="business-courses" className="tp-courses tp-courses--business">
          <div className="tp-courses__inner">
            <div className="tp-courses__header">
              <span className="tp-eyebrow tp-eyebrow--orange">Business Training</span>
              <h2 className="tp-section-title">Training for Organisations</h2>
              <p className="tp-section-sub">
                Sector-specific packages to keep your teams compliant, skilled, and effective.
                Delivered on-site or flexibly to suit your schedule.
              </p>
            </div>

            <div className="tp-courses__grid tp-courses__grid--business">
              {BusinessTrainingData.map((course, index) => (
                <div
                  key={course.id}
                  className="tp-card tp-card--business"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="tp-card__top">
                    <span className="tp-card__badge tp-card__badge--orange">Business Package</span>
                  </div>

                  <div className="tp-card__body">
                    <h3 className="tp-card__title">{course.title}</h3>
                    <p className="tp-card__lead tp-card__lead--orange">{course.shortDescription}</p>
                    <p className="tp-card__desc">{course.description}</p>

                    {course.features && (
                      <div className="tp-card__features">
                        <h4>Package includes:</h4>
                        <ul>
                          {course.features.map((f, i) => (
                            <li key={i}>{f}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>

                  <div className="tp-card__footer">
                    {course.bookingInfo && (
                      <p className="tp-card__booking">{course.bookingInfo}</p>
                    )}
                    <Link
                      to={`/training/business/${course.id}`}
                      className="tp-card__link tp-card__link--orange"
                    >
                      View full details <ArrowRight />
                    </Link>
                  </div>
                </div>
              ))}
            </div>

            <div className="tp-courses__cta tp-courses__cta--orange">
              <p>Need a custom training package for your team?</p>
              <Link to="/contact" className="tp-btn tp-btn--outline-orange">
                Contact us for bulk enrolment
              </Link>
            </div>
          </div>
        </section>

        {/* ── IMPACT / MISSION ── */}
        <section className="tp-impact">
          <div className="tp-impact__inner">
            <div className="tp-impact__text">
              <span className="tp-eyebrow tp-eyebrow--cream">Our Mission</span>
              <h2 className="tp-impact__title">Small organisation. Big heart.</h2>
              <p className="tp-impact__body">
                Founded in 2013 by Emi Gjoni, APT exists to empower individuals and strengthen
                communities through accessible education, employment support, and advocacy.
                We believe everyone deserves the opportunity to thrive, regardless of their
                background, immigration status, or circumstances.
              </p>
              <p className="tp-impact__body">
                Our courses aren't just qualifications — they're life-changing opportunities
                for people who've faced real barriers.
              </p>
              <Link to="/about/mission-values" className="tp-btn tp-btn--ghost">
                Learn about our mission
              </Link>
            </div>

            <div className="tp-impact__stats">
              <div className="tp-impact__stat-card">
                <span className="tp-impact__stat-n">750+</span>
                <span className="tp-impact__stat-l">Community members reached</span>
              </div>
              <div className="tp-impact__stat-card">
                <span className="tp-impact__stat-n">45.7%</span>
                <span className="tp-impact__stat-l">
                  Of job seekers placed into employment — vs 15–20% national average
                </span>
              </div>
              <div className="tp-impact__stat-card">
                <span className="tp-impact__stat-n">£45k+</span>
                <span className="tp-impact__stat-l">In benefits secured through advocacy</span>
              </div>
              <div className="tp-impact__stat-card">
                <span className="tp-impact__stat-n">100+</span>
                <span className="tp-impact__stat-l">Qualifications achieved in 2024–25</span>
              </div>
            </div>
          </div>
        </section>

        {/* ── TESTIMONIALS ── */}
        <section className="tp-testimonials">
          <div className="tp-testimonials__inner">
            <p className="tp-eyebrow">Learner voices</p>
            <h2 className="tp-section-title">What our learners say</h2>

            <div className="tp-testimonials__grid">
              <div className="tp-testimonial">
                <blockquote>
                  "APT gave me the confidence to be part of my community and the skills to help
                  my children with homework."
                </blockquote>
                <div className="tp-testimonial__author">
                  <div className="tp-testimonial__avatar tp-testimonial__avatar--teal">A</div>
                  <div className="tp-testimonial__details">
                    <strong>Amira</strong>
                    <span>Syrian refugee · ESOL &amp; Life Skills</span>
                    <span className="tp-testimonial__outcome">
                      → Now volunteers with APT helping others
                    </span>
                  </div>
                </div>
              </div>

              <div className="tp-testimonial">
                <blockquote>
                  "The courses gave me a qualification I didn't think I would ever have. I now
                  feel confident applying for jobs."
                </blockquote>
                <div className="tp-testimonial__author">
                  <div className="tp-testimonial__avatar tp-testimonial__avatar--teal">B</div>
                  <div className="tp-testimonial__details">
                    <strong>Blessing</strong>
                    <span>Nigerian national · Professional Training</span>
                    <span className="tp-testimonial__outcome">
                      → Secured employment in customer services
                    </span>
                  </div>
                </div>
              </div>

              <div className="tp-testimonial">
                <blockquote>
                  "APT provided our staff with bespoke compliance training. The process was
                  seamless and highly professional."
                </blockquote>
                <div className="tp-testimonial__author">
                  <div className="tp-testimonial__avatar tp-testimonial__avatar--orange">M</div>
                  <div className="tp-testimonial__details">
                    <strong>Mark Dawson</strong>
                    <span>Operations Manager · Business package</span>
                    <span className="tp-testimonial__outcome">
                      → Organisation fully compliance-trained
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── FINAL CTA ── */}
        <section className="tp-final-cta">
          <div className="tp-final-cta__inner">
            <h2>Ready to take the next step?</h2>
            <p>
              Join hundreds of learners and organisations who have grown with APT. Get in touch
              — we'll help you find the right programme.
            </p>
            <div className="tp-final-cta__btns">
              <Link to="/contact" className="tp-btn tp-btn--cta-primary">
                Enquire now <ArrowRight />
              </Link>
              <Link to="/about/our-impact" className="tp-btn tp-btn--cta-secondary">
                See our impact
              </Link>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}


export default Training;
